module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/sugerencia/sugerencia.component.html
// module id = ./src/app/productos/sugerencia/sugerencia.component.html
// module chunks = main